import db from "src/db";

const buildSavedTokenKey = (userId: string) =>
  `NotificationTokenSaved:${userId}`;

export const saveNotificationTokenIfChanged = async (
  userId: string | null,
  token: string | null
) => {
  if (!userId || !token) return false;

  const storageKey = buildSavedTokenKey(userId);
  const savedToken = localStorage.getItem(storageKey);
  if (savedToken === token) return false;

  await db.collection("users").doc(userId).update({
    firebaseNotificationToken: token,
  });

  localStorage.setItem(storageKey, token);
  return true;
};

export const __resetNotificationTokenServiceForTest = (userId: string) => {
  localStorage.removeItem(buildSavedTokenKey(userId));
};
